
import React, { useState, useRef } from 'react';
import '../Style/footer.css'
import mail from '../images/mail.svg'
// import location from '../img/location.png'
import call from '../images/call1.png'
import logo from '../images/Logo.png'
const Footer = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const nameRef = useRef(null);
    const numberRef = useRef(null);
    const companyNameRef = useRef(null);
    const emailRef = useRef(null);
    const messageRef = useRef(null);

    const onSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setIsSubmitted(false);

        const formData = new FormData(event.target);
        // formData.append("access_key", "707f6172-38ae-447a-90b6-c2b28090bf7c");

        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        try {
            const res = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: json
            }).then((res) => res.json());

            if (res.success) {
                setTimeout(() => {
                    setIsLoading(false);
                    setIsSubmitted(true);

                    // Clear input fields after successful submission
                    nameRef.current.value = '';
                    numberRef.current.value = '';
                    companyNameRef.current.value = '';
                    emailRef.current.value = '';
                    messageRef.current.value = '';
                }, 1000);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setIsLoading(false);
        }
    };

    return (
        <div className='from-bg' id='from-bg'>
            <div className='contact-main'>
                <div className='contact-text'>
                    <section className='contact-para'>
                        <h2>GET IN TOUCH</h2>
                        <p>Our dedicated support team is available 24/7 to assist you with any inquiries or concerns. We prioritize fast response times and efficient solutions to ensure a seamless experience. Whether you need help, have questions, or require assistance, we are here to provide reliable and professional support whenever you need it.</p>
                    </section>
                    <section className='contact-info-2'>
                        <div>
                            <img src={mail} width={35} />
                            <p>projects@ideatechhub.com</p>
                        </div>

                        <div>

                            <img src={call} width={35} />
                            <p>+91 99943 33049</p>
                        </div>

                        <div>
                            {/* <img src={location} width={35}/> */}
                            <p>Orchid Center, Kannappan Street,  Nelson Manickam Road,
                                Aminjikarai,<br /> Chennai-600 029.Tamilnadu, India.
                            </p>
                        </div>
                    </section>
                </div>
                <div className='contact-form'>
                    <div className="form-container">
                        <h2>Contact Us</h2>
                        <form onSubmit={onSubmit}>
                            <input type="text" placeholder="Full Name" name='name' required ref={nameRef} />
                            <input type="text" placeholder="Phone Number" name='number' required ref={numberRef} />
                            <input type="text" placeholder="Company Name" name='company_name' required ref={companyNameRef} />
                            <input type="email" placeholder="Email Address" name='email' required ref={emailRef} />
                            <textarea placeholder="Write Message..." name='message' required ref={messageRef}></textarea>

                            <button type="submit" disabled={isLoading}>
                                {isLoading ? 'Sending...' : 'SEND MESSAGE'}
                            </button>
                            {isSubmitted && <p className="success-message">Successfully submitted!</p>}
                        </form>
                    </div>

                </div>
            </div>

            <section className='footer'>
                <div className='footer-main'>
                    <div>
                        <h3>IDEA TECH HUB</h3>
                        <p>Expert energy solutions across power, Oil & Gas, Chemical, Petrochemical, and Renewables.</p>
                        <></>
                    </div>
                    <div>
                        <h3>Quick Links</h3>
                        <div>
                            <a href='#aboutus'>About Us</a>
                            <a href='#capabilities'>Our Capabilities</a>
                            <a href='#process'>Engineering Expertise</a>
                            {/* <a href='#'>Project Experience</a> */}
                            <a href='#global-presence'>Global Presence & Market Focus</a>
                        </div>
                    </div>
                    <div>
                        <h3>Our Services</h3>
                        <div>
                            <p>Process Engineering</p>
                            <p>Piping & Pipeline</p>
                            <p>Mechanical Engineering</p>
                            <p>Civil & Structural</p>
                            <p>Electrical & Instrumentation</p>
                        </div>
                    </div>
                    <div>
                        <h3>Contact</h3>
                        <div>
                            <p> Chennai-600 029, Tamilnadu, India</p>
                            <p> +91 99943 33049</p>
                            <p> projects@ideatechhub.com</p>
                            <p> www.ideatechhub.com</p>
                        </div>
                    </div>
                </div>
                {/* <span></span> */}
                <hr/>
                <p>© 2023 IDEA TECH HUB ENGINEERING LLP. All rights reserved.</p>
            </section>

        </div>
    )
}

export default Footer
